module.exports = __webpack_public_path__ + "assets/img/7.cb8b1a86.png";